import {pluralize} from 'lib/stringUtils';

import {baseGuideLevelExtensions} from '../guideLevelHelpers/baseGuideLevel.extensions';

/**
 * These extensions are mixed (via spread) into the augmented GuideLevel model,
 * so `this` is the host model. We describe the host model surface these methods
 * rely on via a `this` type so the calls type-check without weakening them.
 */
interface GuideLevelExtensionsMeta {
  getCountOfQuestions(): number;
  getStudentCountOfUniqueGuesses(): number;
}

interface GuideLevelExtensionsSubject {
  getUrlSlug(): string;
}

interface GuideLevelExtensionsHost {
  getSubject(): GuideLevelExtensionsSubject;
  getUrlSlug(): string;
  getMeta(): GuideLevelExtensionsMeta;
}

export const extensions = {
  ...baseGuideLevelExtensions,

  getLinkToQuestions(this: GuideLevelExtensionsHost): string {
    return `/learn/${this.getSubject().getUrlSlug()}/${this.getUrlSlug()}`;
  },

  getQuestionMetadataForSubjectView(
    this: GuideLevelExtensionsHost,
    hasTeacherAccess = false
  ): string {
    const questions = this.getMeta().getCountOfQuestions();
    const questionsAnswered = this.getMeta().getStudentCountOfUniqueGuesses();
    if (hasTeacherAccess || !questionsAnswered) {
      return `${questions} ${pluralize('question', questions)}`;
    }
    return `${questionsAnswered}/${questions} ${pluralize('question', questions)}`;
  }
};
